import { ArrowForward } from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListProps,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSupportedBanksQuery } from '../../../api/gql';

type Props = {
  onSelect: (paymentProvider: string) => void;
  transNS?: string;
} & Omit<ListProps, 'onSelect'>;

export const SupportedBankList = ({ onSelect, transNS = 'bank-connection', ...rest }: Props) => {
  const { t } = useTranslation(transNS);

  const { data, isLoading, error } = useSupportedBanksQuery();

  if (error) {
    return <Typography>{t('query.error')}</Typography>;
  }

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <List {...rest}>
      {data?.supportedBanks.map((bank) => (
        <ListItem disableGutters key={bank.paymentProvider}>
          <ListItemButton
            sx={{
              gap: 2,
              py: 2,
              border: 1,
              borderColor: 'divider',
              borderRadius: 1,
            }}
            onClick={() => onSelect(bank.paymentProvider)}
          >
            <ListItemIcon>
              <img src={bank.logoUrl} alt={`${bank.name} logo`} width={72} height={'auto'} />
            </ListItemIcon>
            <ListItemText primary={bank.name} />
            <ArrowForward color={'primary'} sx={{ ml: 4 }} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};
